import { format, formatDistanceToNow } from 'date-fns';

import {
  MatchaTooltip,
  MatchaTooltipBottomSheet,
  MatchaTooltipContent,
  MatchaTooltipPopover,
  MatchaTooltipTrigger,
} from '../../../ui/MatchaTooltip';
import { LimitOrderItem } from '../../../utils/0x.types';

interface TokenDateCellProps {
  /** The open limit order whose expiry is displayed. */
  item: LimitOrderItem;
}

/**
 * Renders an open limit order's expiry as a relative time with the absolute
 * date in a tooltip.
 */
export function TokenDateCell({ item }: TokenDateCellProps) {
  const dateMs = Number(item.expiry) * 1000;
  return (
    <MatchaTooltip>
      <MatchaTooltipTrigger>
        <span>{formatDistanceToNow(new Date(dateMs), { addSuffix: true })}</span>
      </MatchaTooltipTrigger>
      <MatchaTooltipContent>{format(new Date(dateMs), 'Pp')}</MatchaTooltipContent>
      <MatchaTooltipPopover sideOffset={8} />
      <MatchaTooltipBottomSheet header="Date" />
    </MatchaTooltip>
  );
}
